import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=13f3f332&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=ts&"
export * from "./Customers.vue?vue&type=script&lang=ts&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=13f3f332&lang=scss&scoped=true&"
import style1 from "./Customers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f3f332",
  null
  
)

component.options.__file = "Customers.vue"
export default component.exports